import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { TextField, Button, Grid } from '@mui/material';

const FormEstudante = ({ onSubmit, estudanteInicial = {} }) => {
  const [estudante, setEstudante] = useState({
    nome: '',
    email: '',
    dataNascimento: '',
    telefone: '',
    genero: '',
    endereco: '',
    documentoIdentificacao: '',
    tipoDocumento: '',
    ...estudanteInicial
  });

  const handleChange = (e) => {
    setEstudante({ ...estudante, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(estudante);
  };

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Nome"
            name="nome"
            value={estudante.nome ?? ''}
            onChange={handleChange}
            required
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Email"
            name="email"
            type="email"
            value={estudante.email ?? ''}
            onChange={handleChange}
            required
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Data de Nascimento"
            name="dataNascimento"
            type="date"
            value={estudante.dataNascimento ?? ''}
            onChange={handleChange}
            InputLabelProps={{
              shrink: true,
            }}
            required
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Telefone"
            name="telefone"
            value={estudante.telefone ?? ''}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Gênero"
            name="genero"
            select
            value={estudante.genero ?? ''}
            onChange={handleChange}
            SelectProps={{
              native: true,
            }}
          >
            <option value="">Selecione</option>
            <option value="Masculino">Masculino</option>
            <option value="Feminino">Feminino</option>
            <option value="Outro">Outro</option>
          </TextField>
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Endereço"
            name="endereco"
            value={estudante.endereco ?? ''}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Documento de Identificação"
            name="documentoIdentificacao"
            value={estudante.documentoIdentificacao ?? ''}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Tipo de Documento"
            name="tipoDocumento"
            select
            value={estudante.tipoDocumento ?? ''}
            onChange={handleChange}
            SelectProps={{
              native: true,
            }}
          >
            <option value="">Selecione</option>
            <option value="BI">BI</option>
            <option value="Passaporte">Passaporte</option>
            <option value="Outro">Outro</option>
          </TextField>
        </Grid>
        <Grid item xs={12}>
          <Button type="submit" variant="contained" color="primary">
            Salvar
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

FormEstudante.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  estudanteInicial: PropTypes.shape({
    nome: PropTypes.string,
    email: PropTypes.string,
    dataNascimento: PropTypes.string,
    telefone: PropTypes.string,
    genero: PropTypes.string,
    endereco: PropTypes.string,
    documentoIdentificacao: PropTypes.string,
    tipoDocumento: PropTypes.string,
  }),
};

export default FormEstudante;
